module.exports = __webpack_public_path__ + "static/media/fa-light-300.f46e5fd4.ttf";